import { z } from 'zod'
import { id, optionalDate, optionalId, optionalText, requiredText } from './common'

export const templateItemInputSchema = z.object({
  name: requiredText(300, 'שם הפריט הוא שדה חובה'),
  description: optionalText(4000),
})

export type TemplateItemInput = z.infer<typeof templateItemInputSchema>

export const taskTemplateInputSchema = z.object({
  name: requiredText(200, 'שם התבנית הוא שדה חובה'),
  description: optionalText(2000),
  /** Full replacement of the item list, in display order. */
  items: z.array(templateItemInputSchema).max(200).default([]),
})

export type TaskTemplateInput = z.infer<typeof taskTemplateInputSchema>

/**
 * Applying a template copies it: a parent task plus one real task per selected item.
 * There is no live link afterwards — `templateId` is kept for documentation only (spec §4.5).
 */
export const applyTemplateSchema = z.object({
  itemIds: z.array(id()).min(1, 'יש לבחור לפחות פריט אחד'),
  defaultAssigneeId: optionalId(),
  /** itemId → userId, overriding `defaultAssigneeId` for that item. */
  perItemAssignee: z.record(z.string(), z.string()).default({}),
  clientId: optionalId(),
  caseId: optionalId(),
  projectId: optionalId(),
  startDate: optionalDate(),
  dueDate: optionalDate(),
  parentTaskName: optionalText(300),
})

export type ApplyTemplateInput = z.infer<typeof applyTemplateSchema>

export type TemplateItemDto = {
  id: string
  templateId: string
  name: string
  description: string | null
  position: number
}

export type TaskTemplateDto = {
  id: string
  name: string
  description: string | null
  items: TemplateItemDto[]
  createdAt: string
  updatedAt: string
}
